export default __webpack_public_path__ + "static/media/default-dark.48a5b1b5.png";